import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { CalendarCog, Trash2, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { DeletePatientDialog } from '../DeletePatientDialog';

const BookSessionAction = ({ patientId }: { patientId: string }): React.ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <Button
      variant="primary"
      onClick={() =>
        navigate(ROUTES.APPOINTMENTS_RESERVE, {
          state: { patientId },
        })
      }
    >
      {t('InsuredPersonsList.bookSession.cta')}
    </Button>
  );
};

const ManageSessionAction = ({ patientId }: { patientId: string }): React.ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <Button
      variant="terciary"
      icon="leading"
      onClick={() => navigate(generatePath(ROUTES.PATIENT_APPOINTMENT, { id: patientId }))}
    >
      <CalendarCog />
      {t('InsuredPersonsList.manageSession.cta')}
    </Button>
  );
};

const ViewProfileAction = ({ patientId }: { patientId: string }): React.ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <Button
      variant="terciary"
      icon="leading"
      onClick={() => navigate(generatePath(ROUTES.PATIENT_PROFILE, { id: patientId }))}
    >
      <User />
      {t('InsuredPersonsList.viewPerson.cta')}
    </Button>
  );
};

const DeletePatientAction = ({ patientId }: { patientId: string }): React.ReactElement => {
  const { showDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <Button
      variant="destructive_terciary"
      icon="only"
      aria-label={t('RemoveInsuredPersonDialog.cta')}
      onClick={() => showDialog({ component: <DeletePatientDialog userId={patientId} /> })}
    >
      <Trash2 />
    </Button>
  );
};

export const TableActions = ({
  patientId,
  hasUpcomingSession,
}: {
  patientId: string;
  hasUpcomingSession: boolean;
}): React.ReactElement => (
  <div className="flex items-center gap-2 max-am-sm:flex-col">
    {hasUpcomingSession ? (
      <ManageSessionAction patientId={patientId} />
    ) : (
      <BookSessionAction patientId={patientId} />
    )}
    <ViewProfileAction patientId={patientId} />
    <DeletePatientAction patientId={patientId} />
  </div>
);
